import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/api/auth/signin',
		method: 'post',
		data: data
	})
}

AuthService.logout = function (data) {
	return fetch({
		url: 'api/auth/logout',
		method: 'post',
		data: data
	})
}

AuthService.getMe = function () {
	return fetch({
		url: '/api/auth/me',
		method: 'get',
	})
}

export default AuthService;